import React, { useEffect, useState } from 'react';
import Heading from '../../../../../common/element/Heading';
import CoachInfoCard from './CoachInfoCard';
import CompaniesChart from './CompaniesChart';
import CompaniesList from './CompaniesList';
import { setBreadcrumbs } from '../../../../../redux/Admin/breadcrumbsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getCoachById } from '../../../../../redux/Coach/coachSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { CompanyAvatar } from '../../../../../common/element/CompanyAvatar/CompanyAvatar';

// ✅ NEW: Import ImagePreviewModal
import ImagePreviewModal from '../../../../../common/ImagePreviewModal/ImagePreviewModal';

const ViewCoach = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const location = useLocation();
  const navigate = useNavigate();

  // ✅ NEW: State for the Image Preview Modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: "",
    alt: "",
  });

  // Keep tab state synced with URL query param `tab` so it persists across refresh.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = params.get('tab') || 'overview';
    setActiveTab(tabFromUrl);
  }, [location.search]);

  // Read id from query string (?id=10)
  const query = new URLSearchParams(location.search);
  const idFromQuery = query.get('id');
  const coachNameFromQuery = query.get('coachName');

  const dispatch = useDispatch();
  const coachId = idFromQuery ? parseInt(idFromQuery, 10) : null;

  const coachDetail = useSelector((state) => state.coach.getCoachById.data) || null;
  const coachLoading = useSelector((state) => state.coach.getCoachById.loading);
  // We'll pass coachDetail directly to CoachInfoCard and use coachDetail fields here
  const coachData = coachDetail || null;

useEffect(() => {
  dispatch(
    setBreadcrumbs([
      {
        label: "Coaches",
        url: "/coaches",
        home: "/companies",
      },
      {
        label: coachNameFromQuery || "View Coach",
        url: `/coaches/view?id=${coachId}&coachName=${coachNameFromQuery}`,
      }
    ])
  );
}, []);
useEffect(() => {
  if (coachId) {
    dispatch(getCoachById(coachId));
  }
}, [dispatch, coachId]);

  // ✅ NEW: Image Preview Handlers
  const openImagePreview = () => {
    if (!coachData?.user?.profile_image) return;
    setImageModal({ 
      isOpen: true, 
      url: coachData.user.profile_image, 
      alt: (coachData?.user && `${coachData.user.first_name} ${coachData.user.last_name}`) || coachData?.display_name || "Profile Image" 
    });
  };

  const closeImagePreview = () => {
    setImageModal({ isOpen: false, url: "", alt: "" });
  };

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className='w-full'>
          {/* Header Section with Avatar */}
          <div className="flex items-center gap-4 mb-6">
            
            {/* ✅ NEW: Wrap CompanyAvatar in clickable div */}
            <div 
              onClick={openImagePreview}
              className={coachData?.user?.profile_image ? "cursor-pointer hover:opacity-80 transition" : ""}
              title={coachData?.user?.profile_image ? "View Profile Image" : ""}
            >
              <CompanyAvatar logo={coachData?.user?.profile_image} name={ (coachData?.user && `${coachData.user.first_name} ${coachData.user.last_name}`) || coachData?.display_name || '-'} />
            </div>

            <div>
              <div className="w-80 h-10 text-start">
                <Heading>{ (coachData?.user && `${coachData.user.first_name} ${coachData.user.last_name}`) || coachData?.display_name || '-'}</Heading>
              </div>
              <div className="flex items-center gap-3 mt-1">
                <div className={`flex items-center gap-1 px-3 py-0.5 ${coachData?.user?.isActive ? 'bg-[#ECFDF3]' : 'bg-[#FEF3F2]'} rounded-[16px]`}>
                  <div className={`w-2 h-2 ${coachData?.user?.isActive ? 'bg-green-500' : 'bg-red-600'} rounded-full`}></div>
                  <span className={`font-lato font-medium text-[14px] ${coachData?.user?.isActive ? 'text-[#027A48]' : 'text-[#B42318]'}`}>
                    {coachData?.user?.isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
              
                 <span className="font-lato font-medium text-[14px] text-[#1D2939] flex items-center gap-2">

                      <span>{coachData?.user?.email || '-'}</span>
                      {(coachData?.user?.mobile_number || coachData?.work_phone) && (
                        <>
                          {" • "}
                          <span>{coachData?.user?.mobile_number || coachData?.work_phone}</span>
                        </>
                      )}                    </span>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex gap-0 p-1 bg-[#FFF4E5] border border-[#FFF4E5] rounded-lg mb-6">
            <button
              onClick={() => {
                const params = new URLSearchParams(location.search);
                params.set('tab', 'overview');
                navigate(`${location.pathname}?${params.toString()}`, { replace: true });
              }}
              className={`flex-1 text-sm font-normal transition-colors py-2 px-3 rounded-md ${
                activeTab === 'overview'
                  ? 'text-gray-900 bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]' 
                  : 'text-gray-600 bg-[#FFF4E5]'
              }`}
            >
              Overview
            </button>
            <button
              onClick={() => {
                const params = new URLSearchParams(location.search);
                params.set('tab', 'companies');
                navigate(`${location.pathname}?${params.toString()}`, { replace: true });
              }}
              className={`flex-1 text-sm font-normal transition-colors py-2 px-3 rounded-md ${
                activeTab === 'companies'
                  ? 'text-gray-900 bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]'
                  : 'text-gray-600 bg-[#FFF4E5]'
              }`}
            >
              Companies
            </button>
          </div>

          {/* Conditional Tab Rendering */}
          {activeTab === 'overview' && (
            <>
              <CoachInfoCard coachData={coachDetail} />
              <div className="mt-5">
                <CompaniesChart />
              </div>
            </>
          )}

          {activeTab === 'companies' && (
            <CompaniesList />
          )}
        </div>
      </div>

      {/* ✅ NEW: Render the Image Preview Modal */}
      <ImagePreviewModal
        isOpen={imageModal.isOpen}
        onClose={closeImagePreview}
        imageUrl={imageModal.url}
        altText={imageModal.alt}
      />
      
    </div>
  );
};

export default ViewCoach;